import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { SectionProps } from '../types';
import { StyledMightyFuSection } from './style';

export const MightyFuSection: React.FC<SectionProps> = ({
  sectionName,
  image,
}) => (
  <StyledMightyFuSection>
    {image && (
      <div className="section-image">
        <img className="image" src={image} alt={sectionName + `prefix image`} />
      </div>
    )}

    <span className="section-name">
      <AutoTextSize
        maxFontSizePx={20}
        minFontSizePx={10}
        className="section-text"
        mode="oneline"
      >
        {sectionName}
      </AutoTextSize>
    </span>
    {image && (
      <div className="section-image">
        <img className="image" src={image} alt={sectionName + `prefix image`} />
      </div>
    )}
  </StyledMightyFuSection>
);
